var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9 31.7999C24.6 31.7999 24.3417 31.6915 24.125 31.4749C23.9083 31.2582 23.8 30.9999 23.8 30.6999L23.8 10.0999C23.8 9.79988 23.9083 9.54155 24.125 9.32488C24.3417 9.10821 24.6 8.99988 24.9 8.99988L30.7 8.99988C31 8.99988 31.2583 9.10821 31.475 9.32488C31.6917 9.54155 31.8 9.79988 31.8 10.0999L31.8 30.6999C31.8 30.9999 31.6917 31.2582 31.475 31.4749C31.2583 31.6915 31 31.7999 30.7 31.7999L24.9 31.7999ZM10.1 31.7999C9.8 31.7999 9.54167 31.6915 9.325 31.4749C9.10833 31.2582 9 30.9999 9 30.6999L9 10.0999C9 9.79988 9.10833 9.54154 9.325 9.32488C9.54167 9.10821 9.8 8.99988 10.1 8.99988L15.95 8.99988C16.2167 8.99988 16.4667 9.10821 16.7 9.32488C16.9333 9.54154 17.05 9.79988 17.05 10.0999L17.05 30.6999C17.05 30.9999 16.9333 31.2582 16.7 31.4749C16.4667 31.6915 16.2167 31.7999 15.95 31.7999L10.1 31.7999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.ac912cd47b8e474cf0a198da5b3bda12.svg";
export { ForwardRef as ReactComponent };